import React from 'react';
import Expansion from './expansion';
import DetailIndicator from './detailIndicator';
import './detailPanel.scss';

export default class DetailPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            index: -1,
            children: null,
            lastOpen: false
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.index != -1) {
            return {
                index: nextProps.index,
                children: nextProps.children,
                lastOpen: nextProps.open
            };
        } else {
            return {
                lastOpen: nextProps.open
            };
        }
    }

    render() {
        const { columns, open } = this.props;
        const { index, children } = this.state;
        const row = index != -1 ? parseInt(index / columns) : 10000;
        const style = { order: row };
        const className = 'detail-panel' + (open ? ' open' : '');
        const transitionArrow = open && this.state.lastOpen;
        return (
            <div className={className} style={style}>
                <Expansion expanded={open}>
                    <DetailIndicator index={index} columns={columns} transitionArrow={transitionArrow} />
                    <div className='detail-box'>
                        {children}
                    </div>
                </Expansion>
            </div>
        );
    }
}